import styled from "@emotion/styled";

export const PartyImage = styled.div`
    height: 0px;
    padding-bottom: 100%;
    background-size: cover;
`
